import React from 'react';

export const PlayAudioIcon = props => (
    <svg width="20px" height="30px" viewBox="0 0 20 30">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill={props.color} fillRule="nonzero">
                <g>
                    <path d="M19.15,13.35 L3.9,0.7 C3.2,0.15 2.3,4.4408921e-16 1.5,0.4 C0.7,0.75 0.2,1.55 0.2,2.45 L0.2,27.75 C0.2,28.65 0.7,29.45 1.5,29.8 C1.8,29.95 2.15,30 2.45,30 C2.95,30 3.5,29.8 3.9,29.5 L19.15,16.85 C19.65,16.4 19.95,15.8 19.95,15.1 C19.95,14.45 19.65,13.8 19.15,13.35 Z" />
                </g>
            </g>
        </g>
    </svg>
);
